import { usePowerOutageCounties } from 'hooks/map/usePowerOutageCounties';
import type { ArcgisMapView } from './arcgisView';
import {
  POWER_OUTAGE_CLASS_BREAKS,
  POWER_OUTAGE_FIELD,
  POWER_OUTAGE_LAYER_ID,
  buildClassBreaksRenderer,
} from './outageLayerStyles';
import {
  useCountyChoroplethLayerSync,
  type FieldInfoJson,
} from './useCountyChoroplethLayerSync';

const RENDERER = buildClassBreaksRenderer(
  POWER_OUTAGE_CLASS_BREAKS,
  POWER_OUTAGE_FIELD
);

const FIELD_INFOS: FieldInfoJson[] = [
  { fieldName: 'countyName', label: 'County' },
  { fieldName: 'stateName', label: 'State' },
  {
    fieldName: 'customersOut',
    label: 'Customers out',
    format: { places: 0, digitSeparator: true },
  },
  {
    fieldName: 'customersTracked',
    label: 'Customers tracked',
    format: { places: 0, digitSeparator: true },
  },
  { fieldName: 'percentOut', label: 'Percent out', format: { places: 2 } },
  { fieldName: 'lastUpdated', label: 'Last updated (utility)' },
];

/**
 * Keeps the "Power Outages" county choropleth on the map in sync with the
 * latest PowerOutage.us snapshot. Data is only fetched while the layer is
 * visible; the layer is removed when the data goes away.
 */
export function usePowerOutageLayerSync({
  mapView,
  isVisible,
}: {
  mapView: ArcgisMapView | null;
  isVisible: boolean;
}) {
  const { data } = usePowerOutageCounties(isVisible);

  useCountyChoroplethLayerSync({
    mapView,
    layerId: POWER_OUTAGE_LAYER_ID,
    title: 'Power Outages',
    isVisible,
    featureCollection: data?.featureCollection,
    renderer: RENDERER,
    popupTitle: '{countyName}, {stateName} — {percentOut}% out',
    fieldInfos: FIELD_INFOS,
  });
}
